import { Session } from '@benzinga/session';
import { RestfulClient } from '@benzinga/session';
import { UserEnvironment } from '../environment';

export class LavapressRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(UserEnvironment).lavapressUrl, session, { authorizationSession: true });
  }

  public updateProperty = async (email: string, property: string, value: string) => {
    const url = this.URL('user/property');
    // console.log(url, {
    //   email,
    //   property,
    //   value,
    // });
    return this.post(url, {
      email,
      property,
      value,
    });
  };
}
